// ── EDITABLE BUSINESS DETAILS ─────────────────────────────
export const BUSINESS = {
  name: "BHF Creative",
  phoneDisplay: "03119109995",
  phoneIntl: "+92 311 9109995",
  phoneHref: "tel:+923119109995",
  whatsapp: "https://wa.me/923119109995",
  hours: "24 hours open",
  social: {
    facebook: "https://facebook.com/thebhfofficial",
    instagram: "https://instagram.com/thebhfofficial",
    tiktok: "https://tiktok.com/@thebhfofficial",
  },
  // EDITABLE: Google review invitation link — replace when profile is live
  googleReviewLink: "https://g.page/r/CfAHHi9Ymd-DEBM/review",
};

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/b71f0b5d481a98b431b5649c4daf71445bea0ade40a59d2c952290d69df45c25.jpeg",
  founder: "/images/founder.png", 
  studio: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/d4165396f0a33a0184ee889307427a25279932565e2312ba311006dc6f4fa503.jpeg",
  web1: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/7cacd611bf39a1b616d68c6b3a93429e794f0ddd6cc7fbcc0744259b9c8fd3f2.jpeg",
  web2: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/6613e7b574be312275df18f2101b193a46b91eacea1d94d13701d3c499bda200.jpeg",
  web3: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/5c160c42693a6d8c40d0b0ff9e756f53f4c2e89ce63e925cb2ce95a0fe8f5bd4.jpeg",
  video1: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/94ae71c5f5e41744d1c4586e0516a26f16f4590665706f2b0f3aa8724b1771a9.jpeg",
  video2: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/4c9ea8c519050bd3aaa62d3bc472abe4e4657a335f225a67e114fc23028ef709.jpeg",
  video3: "https://static.prod-images.emergentagent.com/jobs/21bddd7d-10b1-4c83-ba23-4aedc377646a/images/a7cfb926e099d3b679e39652656560f682697c6c045816ebb3061e369a72cfc4.jpeg",
};

// lat/lon → equirectangular positions for the world map (viewBox 1000×500)
export const COUNTRIES = [
  { name: "United States", x: 228, y: 142 },
  { name: "Canada", x: 206, y: 94 },
  { name: "Bermuda", x: 320, y: 161 },
  { name: "United Kingdom", x: 494, y: 100 },
  { name: "Ireland", x: 478, y: 103 },
  { name: "Spain", x: 489, y: 139 },
  { name: "Netherlands", x: 515, y: 106 },
  { name: "Switzerland", x: 523, y: 120 },
  { name: "Monaco", x: 521, y: 129 },
  { name: "Denmark", x: 526, y: 94 },
  { name: "Norway", x: 524, y: 81 },
  { name: "Sweden", x: 542, y: 78 },
  { name: "Iceland", x: 450, y: 69 },
  { name: "Pakistan", x: 693, y: 166 },
  { name: "Singapore", x: 788, y: 246 },
  { name: "Australia", x: 869, y: 319 },
];

// EDITABLE: stat per client-provided copy
export const MARKETS_STAT = 18;

export const FAQS = [
  {
    q: "Can you really deliver everything over WhatsApp?",
    a: "Yes. Briefs, proposals, previews, revisions and final delivery all happen in one WhatsApp thread. You message the person actually doing the work — no ticket systems, no account managers in between. For larger files we share secure download links in the same chat.",
  },
  {
    q: "Do you work with clients outside Pakistan?",
    a: "Absolutely , most of our focus is international. We work with small businesses across the US, UK, Canada, Australia, Europe, Singapore and beyond. Everything is handled remotely, so your timezone is never a blocker: we agree on overlap hours up front.",
  },
  {
    q: "How many revisions are included?",
    a: "Your satisfaction is our top priority. We offer continuous revisions until the final website is officially handed over to you. Our team carefully understands your requirements, and we always strive to deliver a design you will completely love within the first one or two iterations"
  },
  {
    q: "How long does a typical project take?",
    a: "Expect rapid results without compromising on quality. We will deliver an initial working demo of your website within just 1 hour. Your fully finalized website will be ready for launch within 24 to 48 hours, depending on the project's complexity",
  },
  {
    q: "Who owns the final files?",
    a: "Upon final payment, you retain 100% ownership of your completed website and all associated files. As a standard professional practice, we securely keep a backup copy of your project on file. This ensures that if you ever need future updates, changes, or accidentally lose your data, our team is ready to assist you immediately.",
  },
  {
    q: "Will I be charged for updates or changes after the final version is delivered?",
    a: "Yes. Once the final website is officially handed over, any future updates, modifications, or additions will be billed separately. The charges are always calculated fairly based on the scope and complexity of the new requests.",
  },
  {
    q: "Do you offer hosting or monthly maintenance packages?",
    a: "Yes, we offer fully managed monthly subscriptions. If you prefer not to purchase and manage your own web hosting, we can securely host your website on our premium servers. Please reach out to us directly on WhatsApp to discuss our monthly packages and find the best plan for your business.",
  }
];

export const PORTFOLIO = [
  { type: "web", title: "E-commerce storefront", tag: "Website Design", img: IMG.web3, desc: "Concept: menswear store with a dark, conversion-focused grid layout." },
  { type: "video", title: "Sneaker launch ad", tag: "Video Ad", img: IMG.video1, desc: "Concept: 15s product ad with kinetic light-trail motion design." },
  { type: "web", title: "Coaching landing page", tag: "Website Design", img: IMG.web2, desc: "Concept: bold single-page funnel built for paid traffic." },
  { type: "video", title: "Café brand spot", tag: "Video Ad", img: IMG.video2, desc: "Concept: atmospheric 20s spot for a specialty coffee brand." },
  { type: "web", title: "Restaurant website", tag: "Website Design", img: IMG.web1, desc: "Concept: dark-theme site with menu highlights and ordering CTAs." },
  { type: "video", title: "Smartwatch teaser", tag: "Video Ad", img: IMG.video3, desc: "Concept: tech teaser with rotating product and gradient lighting." },
];

export const PROCESS = [
  { n: "01", t: "WhatsApp intro", d: "Message us your idea. We reply directly — no forms lost in an inbox." },
  { n: "02", t: "Proposal", d: "A clear scope, deliverables and price. No jargon, no padding." },
  { n: "03", t: "Design / Production", d: "We build. You get progress previews straight in the chat." },
  { n: "04", t: "Revisions", d: "Your feedback, applied fast. We iterate until it feels right." },
  { n: "05", t: "Delivery", d: "Final files, live site, everything handed over cleanly." },
];

export const WHY = [
  { t: "Design + video, one studio", d: "Your website and your ads come from the same creative brain — one consistent brand, no vendor juggling." },
  { t: "Fast WhatsApp turnaround", d: "Questions answered in a chat, not a ticket queue. Decisions happen in hours, not weeks." },
  { t: "Direct founder access", d: "No account managers, no middle layers. You talk to the people doing the work." },
  { t: "Transparent process", d: "Clear proposals, visible progress, honest timelines. You always know where your project stands." },
];